/* RS Extract and RS kit product pages (snippets/os-rsx.liquid).
   1. The 3D items in the gallery: when one is shown, the three.js bundle,
      the models it needs and the viewer load (once), then the viewer
      mounts on it; showing anything else unmounts it.
   2. Links to a place further down the page glide there instead of
      jumping. */
(function () {
  var cfgEl = document.querySelector('[data-rsx-cfg]');
  var pd = document.querySelector('[data-os-pd]');
  if (!cfgEl || !pd) return;
  var cfg = JSON.parse(cfgEl.textContent);
  window.__RSX_A = cfg.a;

  var loaded = {};
  function load(src) {
    if (!loaded[src]) loaded[src] = new Promise(function (res, rej) {
      var s = document.createElement('script'); s.src = src; s.async = false;
      s.onload = res; s.onerror = rej; document.head.appendChild(s);
    });
    return loaded[src];
  }
  var NEED = {
    'rs-extract': ['rs'],
    'brew-control-system-rs': ['rs', 'ti'],
    'sensory-brew-control-system-rs': ['rs', 'ti', 'moment'],
    'sensory-brew-control-system-ultimate-rs': ['rs', 'ti', 'moment', 'omni']
  };
  function ready(shot) {
    var mode = shot.getAttribute('data-mode'), kit = shot.getAttribute('data-kit');
    var glbs = mode === 'set' ? (NEED[kit] || ['rs']) : [mode];
    return load(cfg.three)
      .then(function () { return Promise.all(glbs.map(function (g) { return g === 'rs' && window.__RSS_GLB ? null : load(cfg.glb[g]); })); })
      .then(function () { return load(cfg.viewer); });
  }

  var viewer = null, current = null;
  function sync() {
    var shot = pd.querySelector('.os-pd__stage > .os-pd__shot.is-on');
    if (shot === current) return;
    current = shot;
    if (viewer) { viewer.destroy(); viewer = null; }
    if (!shot || !shot.classList.contains('rsx-3d')) return;
    shot.classList.remove('is-live', 'is-focus');
    ready(shot).then(function () {
      if (current !== shot || !window.RS3D) return;
      viewer = window.RS3D.mount(shot, { kit: shot.getAttribute('data-kit'), mode: shot.getAttribute('data-mode') });
    }).catch(function () { shot.classList.add('rs3d--nogl'); });
  }
  pd.addEventListener('click', function (e) { if (e.target.closest('.os-pd__thumb')) setTimeout(sync, 0); });

  /* Start once the gallery is near the screen. */
  var stage = pd.querySelector('.os-pd__stage');
  if (stage && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      if (es.some(function (x) { return x.isIntersecting; })) { io.disconnect(); sync(); }
    }, { rootMargin: '200px' });
    io.observe(stage);
  } else { sync(); }

  /* Glide to places further down the page. */
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  pd.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]'); if (!a) return;
    var id = a.getAttribute('href').slice(1); if (!id) return;
    var t = document.getElementById(id); if (!t) return;
    e.preventDefault();
    var hd = document.querySelector('.os-header');
    var off = (hd ? Math.max(0, hd.getBoundingClientRect().bottom) : 0) + 16;
    window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - off, behavior: reduce ? 'auto' : 'smooth' });
  });
})();
